<h2 mat-dialog-title>{{ errorAlertTitle }}</h2>
<mat-dialog-content class="mat-typography">
  <p [innerHtml]="errorAlertContent" [ngClass]="errorBodyClass"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close color="primary">Ok</button>
</mat-dialog-actions>
